
export default {
    namespaced: true,
    state: {
        chartData: [],
        currentBrand: null,
    },
    getters: {
        CHART_DATA: state => {
            return state.chartData;
        },
        CURRENT_BRAND: state => {
            return state.currentBrand;
        },
    },
    mutations: {
        CURRENT_BRAND: (state, payload) => {
            return state.currentBrand = payload;
        },
        CHART_DATA: (state, payload) => {
            return state.chartData = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay ++;
            // set null for rewrite vue component
            state.currentBrand = null
            payload.th.$forceUpdate()
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand/dynamics/' + payload.id,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    // set current brand
                    state.currentBrand = responseData.brand
                    // set data
                    let groupByCountry = {};
                    for(let key in responseData.data) {
                        let val = responseData.data[key];
                        if (groupByCountry[val.countryName] == undefined) {
                            groupByCountry[val.countryName] = {
                                labels: [],
                                datasets: [{
                                    label: val.countryName,
                                    data: [],
                                    borderWidth: 1
                                }]
                            };
                        }
                        groupByCountry[val.countryName].labels.push(val.year +'-'+ val.month);
                        groupByCountry[val.countryName].datasets[0].data.push(val.frequency);
                    }
                    state.chartData = [];
                    for (let key in groupByCountry) {
                        state.chartData.push(groupByCountry[key]);
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }
    }
}